import React, { FC, useState, useRef, useEffect, ReactNode } from 'react';

interface IParagraphProps {
  children: string;
  ellipsis?: {
    rows?: number;
    expandable?: boolean;
  };
  classNames?: {
    text?: string;
    toggle?: string;
  };
  color?: {
    text?: string;
    toggle?: string;
  };
  background?: {
    text?: string;
    toggle?: string;
  };
  copyable?: boolean;
  copyIcon?: ReactNode;
}

export const Paragraph: FC<IParagraphProps> = (props) => {
  const {
    children,
    ellipsis,
    classNames = { text: '', toggle: '' },
    color = { text: '', toggle: '' },
    background = { text: '#ffffff', toggle: '#ffffff' },
    copyable,
    copyIcon,
  } = props;

  const [expanded, setExpanded] = useState<boolean>(false);
  const [showExpandButton, setShowExpandButton] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ellipsis?.expandable) {
      return;
    }

    const text = textRef.current;

    if (!text) {
      return;
    }

    const calculate = () => {
      const text = textRef.current;

      if (!text) {
        return;
      }

      // @ts-ignore
      text.style.WebkitLineClamp = 'unset';
      text.style.display = 'block';
      const fullHeight = text.getBoundingClientRect().height;

      // @ts-ignore
      text.style.WebkitLineClamp = String(ellipsis.rows);
      text.style.display = '-webkit-box';
      const clampedHeight = text.getBoundingClientRect().height;

      setShowExpandButton(fullHeight > clampedHeight);
    };

    const observer = new ResizeObserver(() => {
      if (expanded) {
        return;
      }

      calculate();
    });

    observer.observe(text);

    return () => observer.disconnect();
  }, [ellipsis?.expandable, children, expanded]);

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <span
        ref={textRef}
        className={classNames.text}
        style={{
          ...(ellipsis?.expandable && !expanded ? { display: '-webkit-box' } : { display: 'inline' }),
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          WebkitLineClamp: ellipsis?.rows,
          wordBreak: 'break-all',
          lineHeight: 1.5,
          color: color.text,
        }}
      >
        {children}

        <span style={{ textWrap: 'nowrap' }}>
          {showExpandButton && expanded && (
            <span
              className={classNames.toggle}
              style={{ marginLeft: 4, textWrap: 'nowrap', cursor: 'pointer', color: color.toggle }}
              onClick={() => setExpanded((prev) => !prev)}
            >
              Свернуть
            </span>
          )}

          {copyable && (
            <span
              style={{ position: 'relative', marginLeft: 4, marginBottom: -2, width: 20, height: 16, display: 'inline-block' }}
            >
              <span
                style={{
                  position: 'absolute',
                  top: '50%',
                  transform: 'translate(0, -50%)',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => navigator.clipboard.writeText(children)}
              >
                {copyIcon}
              </span>
            </span>
          )}
        </span>
      </span>

      {showExpandButton && !expanded && (
        <span
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            marginBottom: 1,
            backgroundColor: background.toggle,
            lineHeight: 1.5,
          }}
        >
          <span
            className={classNames.toggle}
            style={{ textWrap: 'nowrap', cursor: 'pointer' }}
            onClick={() => setExpanded((prev) => !prev)}
          >
            <span className={classNames.toggle}>...</span>
            <span className={classNames.toggle} style={{ marginLeft: 4, color: color.toggle }}>
              Показать все
            </span>
          </span>

          {copyable && (
            <span
              style={{ position: 'relative', marginLeft: 4, marginBottom: -2, width: 20, height: 16, display: 'inline-block' }}
            >
              <span
                style={{
                  position: 'absolute',
                  top: '50%',
                  transform: 'translate(0, -50%)',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => navigator.clipboard.writeText(children)}
              >
                {copyIcon}
              </span>
            </span>
          )}
        </span>
      )}
    </div>
  );
};
